import palette from 'constants/palette'
import React from 'react'

type Props = {
  className?: string
  strokeColor?: string
}

// Order-stage rail glyph: "order confirmed" (Live Updates Overview tab). Geometry is the
// Sketch prototype's own (live-updates-onboarding v31, `ICON2`), traced rather
// than approximated so the rail reads as one set.
const OrderConfirmed = ({ className, strokeColor = palette.grey90 }: Props) => (
  <svg
    className={className}
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 12l2 2 4-4" />
    <circle cx="12" cy="12" r="9" />
  </svg>
)

export default OrderConfirmed
